import { create } from 'zustand';
import type { IEMCustomer } from '@/services/iem/types';

interface IemFrontDoorState {
  currentCustomer: IEMCustomer | null;
  serviceStartTime: number | null;
  setCustomer: (customer: IEMCustomer | null) => void;
  startServiceTimer: () => void;
  reset: () => void;
  getPersistedIndividualId: () => string | null;
}

export const useIemFrontDoorStore = create<IemFrontDoorState>((set) => ({
  currentCustomer: null,
  serviceStartTime: null,
  setCustomer: (customer) => {
    set({ currentCustomer: customer });
    if (customer?.individual_id) {
      sessionStorage.setItem('iem-customer-individual-id', customer.individual_id);
    } else {
      sessionStorage.removeItem('iem-customer-individual-id');
    }
  },
  startServiceTimer: () => set({ serviceStartTime: Date.now() }),
  reset: () => {
    set({ currentCustomer: null, serviceStartTime: null });
    sessionStorage.removeItem('iem-customer-individual-id');
  },
  getPersistedIndividualId: () => sessionStorage.getItem('iem-customer-individual-id'),
}));
